import React, { useContext } from 'react';
import cn from 'classnames';
import StageBackground from '../../../DeviationBackground/StageBackground';
import DeviationFullView from '../../../DeviationViews/Full';
import DuperbrowsePaddles from '../../../Duperbrowse/DuperbrowsePaddles';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import s from './SimpleStage.scss';
const SimpleStage = ({ deviation })=>{
    const { needsSubscription } = useSubscriptionTier(deviation);
    const { isTheater } = useDeviationViewContext();
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['stage'], needsSubscription && s['stage-locked'])
    }, /*#__PURE__*/ React.createElement(StageBackground, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['stage-content'], needsSubscription && s['content-locked'], isTheater && s['content-locked-theater'])
    }, /*#__PURE__*/ React.createElement(DeviationFullView, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: s['duperbrowse']
    }), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, null));
};
SimpleStage.displayName = 'SimpleStage';
export default SimpleStage;

//# sourceMappingURL=SimpleStage.js.map